import { Box, Flex, StyleProps, useIsMobileView } from 'deepstash-ui';
import SourceProvider from 'providers/source/SourceProvider';
import React, { useMemo } from 'react';
import SourceCollapsed from 'src/components/source/source-collapsed/SourceCollapsed';
import useAuth from 'src/providers/hooks/useAuth';
import useCollection from 'src/providers/hooks/useCollection';
import { Source } from 'types/models';
import CollectionSourceHighlightedIdeas from './CollectionSourceHighlightedIdeas';

interface CollectionSourceCardProps {
  source: Source;
}

const CollectionSourceCard: React.FC<
  CollectionSourceCardProps & StyleProps
> = ({ source, ...props }) => {
  const { collection } = useCollection();
  const isMobileView = useIsMobileView();
  const { isLoggedIn } = useAuth();

  const highlightedIdeas = useMemo(() => {
    if (!collection || !source) return [];
    return source.ideas.slice(0, 3);
    // return source.ideas.filter(idea => !!idea.isFeaturedInCollection);
  }, [source.ideas]);

  if (!collection) return null;

  return (
    <Box
      pos="relative"
      key={`collection-source-collapsed-${source.id}`}
      {...props}
    >
      {isMobileView ? (
        <>
          <SourceCollapsed size="large" source={source} />
          {!isLoggedIn && highlightedIdeas.length > 0 && (
            <Flex width="100%" overflowX="scroll">
              <CollectionSourceHighlightedIdeas
                ideas={highlightedIdeas}
                source={source}
              />
            </Flex>
          )}
        </>
      ) : (
        <SourceProvider source={source}>
          <SourceCollapsed
            shouldHideCta={highlightedIdeas.length > 0}
            showTopics
            size="full"
          />
          {!isLoggedIn && highlightedIdeas.length > 0 && (
            <CollectionSourceHighlightedIdeas
              ideas={highlightedIdeas}
              source={source}
            />
          )}
        </SourceProvider>
      )}
    </Box>
  );
};

export default CollectionSourceCard;
